import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiConfig from "../axiosConfig";

const initialState = {
	productsList: [],
	flashSaleList: [],
	labels: [],
	merchants: [],
	categories: [],
	voucherTypes: [],
	status: null,
	error: null,
};

export const getAllFlashSales = createAsyncThunk("flashSaleManagement/fetchAssets", async ({ id }) => {
	if (id == null) id = "my";
	const response = await apiConfig
		.get(`flash-sale/list/${id}/1`)
		.then((response) => response)
		.catch((error) => error);

	return response;
});

export const addFlashSale = createAsyncThunk("flashSale/addFlashSale", async (payload) => {
	let updatePayload = { ...payload };
	const response = await apiConfig
		.post(`flash-sale/add`, { ...updatePayload })
		.then((response) => response)
		.catch((error) => error);

	const data = (await response) && response.data ? response.data : response;
	return { ...data };
});

export const updateFlashSale = createAsyncThunk("flashSale/updateFlashSale", async (payload) => {
	let updatePayload = { ...payload };
	const response = await apiConfig
		.put(`flash-sale/update/${payload.id}`, { ...updatePayload })
		.then((response) => response)
		.catch((error) => error);

	const data = (await response) && response.data ? response.data : response;
	return { ...data };
});

export const getAllFlashSaleProducts = createAsyncThunk("flashSale/getAllProducts", async ({ flashSaleId }) => {
	if (flashSaleId != null) {
		const response = await apiConfig
			.get(`flashSale/getAllProducts${flashSaleId}`)
			.then((response) => response)
			.catch((error) => error);

		return response;
	}
});

export const deleteFlashSale = createAsyncThunk("giftSkuManagement/deleteFlashSale", async ({ flashSaleId }) => {
	const response = await apiConfig
		.delete(`flash-sale/delete/${flashSaleId}`)
		.then((response) => response)
		.catch((error) => error);

	const data = (await response) && response.data ? response.data : response;
	return { ...data, flashSaleId };
});

export const uploadImageProduct = async (payload) => {
	const formData = new FormData();
	formData.append("file", payload.image, payload.image.name);
	return apiConfig
		.post(`product-management/upload`, formData)
		.then((response) => response)
		.catch((error) => error);
};

const flashSaleSlice = createSlice({
	name: "flashSale",
	initialState,
	reducers: {},
	extraReducers: {
		[getAllFlashSales.pending]: (state) => {
			state.status = "loading";
		},
		[getAllFlashSales.fulfilled]: (state, action) => {
			const response = action.payload.data;
			if (response?.status === "OK") {
				state.flashSaleList = [];
				state.status = "OK";
				state.flashSaleList = action.payload.data.data.sections.flashSales;
				state.labels = action.payload.data.data.sections.labels;
				console.log("flashList::>", action.payload.data.data.sections.flashSales)
			} else {
				state.status = "failed";
				state.flashSaleList = [];
				state.labels = [];
				state.error = action?.error?.message || action?.payload?.message;
			}
			
		},
		[getAllFlashSales.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.error.message;
		},
		[addFlashSale.fulfilled]: (state, action) => {
			const response = action.payload;
			if (response.status === "CREATED") {
				const itemIndex = state.flashSaleList.findIndex((item) => item.id === action.payload.data.id);
				if (itemIndex === -1) {
					state.flashSaleList = [...state.flashSaleList, action.payload.data];
				} else {
					state.flashSaleList[itemIndex] = action.payload.data;
				}
			} else {
				state.status = "failed";
				state.error = action.message;
			}
		},
		[deleteFlashSale.fulfilled]: (state, action) => {
			const response = action.payload;
			if (response.status === "ACCEPTED") {
				const itemIndex = state.flashSaleList.findIndex((item) => item.id === response.flashSaleId);
				if (itemIndex !== -1) {
					state.flashSaleList[itemIndex].isDeleted = !state.flashSaleList[itemIndex].isDeleted;
				}
			} else {
				state.status = "failed";
				state.error = action?.error?.message || "";
			}
		},
	},
});

export const assetManagementActions = flashSaleSlice.actions;
export default flashSaleSlice.reducer;
